export const updateNewsQouteStream = (data, stream) => {
    const news = data.map((z) => {
        var _a, _b;
        if (((_a = z.customElements) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            const content = (_b = z.customElements) === null || _b === void 0 ? void 0 : _b.map((y) => {
                if ((y === null || y === void 0 ? void 0 : y.sym) === stream.symbol) {
                    return Object.assign(Object.assign({}, y), { chgP: stream.changePercentage });
                }
                else {
                    return y;
                }
            });
            return Object.assign(Object.assign({}, z), { customElements: content });
        }
        else {
            return z;
        }
    });
    return news;
};
